const Jars = [
    {
        key: 1, 
        category: "Necessity",
        dollar: 50
    },
    {
        key: 2, 
        category: "Financial Freedom",
        dollar: 10
    },
    {
        key: 3, 
        category: "Long-term Savings",
        dollar: 10
    },
    {
        key: 4, 
        category: "Education",
        dollar: 10
    },
    {
        key: 5, 
        category: "Play",
        dollar: 10
    },
    {
        key: 6, 
        category: "Give",
        dollar: 10
    }
]

export default Jars